import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  inject
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Subscription, tap } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { IGetTipoCarreta } from 'src/app/services/TipoCarretaService/tipoCarreta.model';
import { TipoCarretaService } from 'src/app/services/TipoCarretaService/tipoCarreta.service';
import { formatarData, removeHyphen } from 'src/app/core/utils/utilities';
import {
  ICreateServicoEntrada,
  IGetServicosEntradaByCavalo,
  IGetServicosEntradaByGateEntrada,
  IUpdateServicoEntrada
} from 'src/app/services/ServicoEntradaService/servicoEntrada.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { CargaService } from 'src/app/services/CargaService/carga.service';
import { IGetServico } from 'src/app/services/ServicoService/servico.model';
import { IGetCarga } from 'src/app/services/CargaService/carga.model';
import { EntradaGateService } from 'src/app/services/EntradaGateService/entradaGate.service';
import { ServicoEntradaService } from 'src/app/services/ServicoEntradaService/servicoEntrada.service';
import Swal from 'sweetalert2';
import {
  ICreateServicoResponse,
  IGetServicoEntradaByIdResponse,
  IGetServicosEntradaByCavaloResponse
} from './cadastro-entrada-servicos.model';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { PrecoService } from 'src/app/services/PrecoService/preco.service';
import { IGetPreco } from 'src/app/services/PrecoService/preco.model';
import { CaixaService } from 'src/app/services/CaixaService/caixa.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-entrada-servicos',
  templateUrl: './cadastro-entrada-servicos.component.html',
  styleUrls: ['./cadastro-entrada-servicos.component.scss']
})
export class CadastroEntradaServicosComponent
  implements OnInit, AfterViewInit, OnDestroy {
  private subscription$ = new Subscription();
  form: FormGroup;
  activeRoute: string = '';
  title: string = 'Entrada de Serviços';
  statusInput: boolean = false;
  isViewing: boolean = false;
  isEditing: boolean = false;
  isLoading: boolean = false;
  guid = generateUUID();
  public precosRaw: any[] = [];
  public servicosRaw: IGetServico[] = [];
  NU_TIPO_CAIX: number | null = null;
  placaComEntradaAtiva: boolean = false;
  isPatching: boolean = false;
  private timeoutPreco: any;

  private entradaGateService = inject(EntradaGateService);
  private servicoService = inject(ServicoService);
  private servicoEntradaService = inject(ServicoEntradaService);
  private tipoCarretaService = inject(TipoCarretaService);
  private tipoCargaService = inject(CargaService);
  private precoService = inject(PrecoService);
  private caixaService = inject(CaixaService);
  private appExportBase64 = inject(AppExportBase64);
  private impressoraService = inject(ImpressoraService);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public swalAlert: SwalAlertService
  ) {
    this.form = this._inicializarFormulario();
  }

  ngOnInit(): void {
    this.activateRoute();
    this.getCaixaAtual();
  }

  ngAfterViewInit(): void { }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCarretaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCargaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoEixosOptions: IOptions[] = [
    {
      name: '3 Eixos',
      value: 3
    },
    {
      name: '4 Eixos',
      value: 4
    },
    {
      name: '7 Eixos',
      value: 7
    },
    {
      name: '9 Eixos',
      value: 9
    }
  ];

  qtdCompartimentosOptions: IOptions[] = [
    {
      name: '0',
      value: 0
    },
    {
      name: '1',
      value: 1
    },
    {
      name: '2',
      value: 2
    },
    {
      name: '3',
      value: 3
    }
  ];

  precosOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tableColumns: Array<any> = [
    { header: 'Serviço', key: 'tipoServico', type: 'text' },
    { header: 'Cód. Serviço', key: 'servico', type: 'text' },
    { header: 'Tipo Carreta', key: 'tipoCarreta', type: 'text' },
    { header: 'Qtd. Eixos', key: 'quantidadeEixos', type: 'text' },
    {
      header: 'Qtd. Compart.',
      key: 'quantidadeCompartimentos',
      type: 'text'
    },
    { header: 'Tipo Carga', key: 'tipoCarga', type: 'text' },
    { header: 'Valor', key: 'valorServico', type: 'text' },
    { header: 'Operador', key: 'operador', type: 'text' },
    { header: 'Início Serviço', key: 'inicioServico', type: 'text' },
    { header: 'Entrada no Gate', key: 'gateEntrada', type: 'text' }
  ];

  tableData: Array<any> = [];

  private _inicializarFormulario() {
    const form = this.fb.group({
      TX_PLCA_CAVA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      PK_AGND: this.fb.control(null, {}),
      DT_GATE_ENTR: this.fb.control(null),
      DT_FILA: this.fb.control(null, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      FK_GATE_ENTR: this.fb.control(null),
      FK_SRVC: this.fb.control(null, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      QT_CPTM: this.fb.control(0),
      FK_TIPO_CRRT: this.fb.control(null, {
        nonNullable: true
      }),
      FK_CRGA: this.fb.control(null, {
        nonNullable: false
      }),
      QT_TOTL_EIXO: this.fb.control(0, {
        nonNullable: true
      }),
      TX_OBSV_SRVC_ENTR: this.fb.control(null, {
        nonNullable: true
      }),
      PK_PRCO: this.fb.control(null),
      PK_SRVC_ENTR: this.fb.control(null)
    });
    return form;
  }

  createPayload(): ICreateServicoEntrada | IUpdateServicoEntrada {
    const FK_FUNC_OPER = Number(localStorage.getItem('id'));

    return {
      FK_GATE_ENTR: Number(this.form.controls['FK_GATE_ENTR'].value),
      FK_FUNC_OPER: FK_FUNC_OPER,
      FK_SRVC: Number(this.form.controls['FK_SRVC'].value),
      FK_TIPO_CRRT: Number(this.form.controls['FK_TIPO_CRRT'].value),
      FK_CRGA: Number(this.form.controls['FK_CRGA'].value ?? 0),
      QT_TOTL_EIXO: Number(this.form.controls['QT_TOTL_EIXO'].value),
      TX_OBSV_SRVC_ENTR: this.form.controls['TX_OBSV_SRVC_ENTR'].value,
      QT_CPTM: Number(this.form.controls['QT_CPTM'].value),
      TX_PLCA_CAVA: this.form.controls['TX_PLCA_CAVA'].value
    };
  }

  postDados() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.swalAlert.showAlert(
        'Atenção!',
        'Preencha todos os campos obrigatórios.',
        'warning'
      );
      return;
    }

    if (this.placaComEntradaAtiva && !this.form.controls['FK_GATE_ENTR'].value) {
      this.swalAlert.showAlert(
        'Atenção!',
        'A placa possui entrada ativa no gate, mas o vínculo não foi carregado. Recarregue a placa antes de salvar.',
        'warning'
      );
      return;
    }

    const payload = this.createPayload();

    const preco = (this.precosRaw.find(p => p.PK_PRCO == this.form.controls['PK_PRCO'].value)).NM_PRCO;

    if (!this.isEditing) {
      Swal.fire({
        title: 'Atenção!',
        html: `<p>Deseja confirmar o cadastro do serviço <b>${preco}</b>?<br>Não será possível realizar a exclusão das atividades!</p>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: 'red',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }).then(result => {
        if (result.isConfirmed) {
          this.createServico(payload as ICreateServicoEntrada);
        } else if (result.isDenied || result.isDismissed) { }
      });
      this.activateRoute();
      return;
    }
    else {
      this.swalAlert.showAlert(
        'Atenção!',
        'Deseja confirmar a edição?',
        'warning',
        true,
        true,
        undefined,
        () => {
          this.updateServico(payload as IUpdateServicoEntrada);
        }
      );
      return;
    }
  }

  createServico(payload: ICreateServicoEntrada) {
    this.isLoading = true;
    this.servicoEntradaService.CreateServico(payload, this.guid).subscribe({
      next: (response: ICreateServicoResponse) => {
        this.isLoading = false;

        this.getTabela();
        this.form.reset();
        this.swalAlert.showAlert(
          'Sucesso!',
          'Serviço cadastrado com sucesso',
          'success'
        );
        this.activateRoute();
        this.guid = generateUUID();

        this.router.navigate(['listagem/caixa'], {
          queryParams: {
            placa: payload.TX_PLCA_CAVA
          }
        });
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  updateServico(payload: IUpdateServicoEntrada) {
    this.isLoading = true;
    const id = this.form.controls['PK_SRVC_ENTR'].value;

    this.servicoEntradaService.UpdateServico(id, payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.getTabela();
        this.swalAlert.showAlert(
          'Sucesso!',
          'Serviço editado com sucesso',
          'success',
          true,
          false,
          undefined,
          () => {
            this.router.navigate(['cadastro/laudo-higienizacao'], {
              queryParams: {
                placa: payload.TX_PLCA_CAVA
              }
            });
          }
        );
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  getEntrada() {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    const numeroAgendamento = this.form.controls['PK_AGND'].value;

    if (!placaCavalo && !numeroAgendamento) return;

    const payload = {
      placaCavalo,
      numeroAgendamento,
      status: 1
    };

    this.isLoading = true;
    this.entradaGateService.GetEntradasGate(payload).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.ITEMS.length > 0) {
          const data = response.ITEMS[0];
          this.placaComEntradaAtiva = true;
          this.form.patchValue({
            PK_AGND: data.PK_AGND,
            TX_PLCA_CAVA: data.TX_PLCA_CAVA,
            FK_GATE_ENTR: data.PK_GATE_ENTR,
            DT_GATE_ENTR: formatarData(data.DT_GATE_ENTR)
          });
          if (!this.isViewing) {
            this.getTabela();
          }
        }
        else {
          this.placaComEntradaAtiva = false;
          this.form.patchValue({
            TX_PLCA_CAVA: placaCavalo,
            FK_GATE_ENTR: null
          });
        }
      },
      error: () => {
        this.isLoading = false;
        this.exibirMensagem('Erro ao carregar as entradas', 'error');
      }
    });
  }

  getTabela() {
    if (!this.form.controls['FK_GATE_ENTR'].value) {
      return;
    }

    let params: IGetServicosEntradaByGateEntrada = { PK_GATE_ENTR: 0 };

    if (this.form.controls['FK_GATE_ENTR'].value) {
      params.PK_GATE_ENTR = this.form.controls['FK_GATE_ENTR'].value;
    }

    this.servicoEntradaService
      .GetServicosEntradaByGateEntrada(params)
      .subscribe({
        next: (response: IGetServicosEntradaByCavaloResponse[]) => {
          this.tableData = response.map(
            (item: IGetServicosEntradaByCavaloResponse) => {
              return {
                tipoServico: item.TX_TIPO_SRVC,
                servico: item.PK_SRVC_ENTR,
                idGateEntrada: this.form.controls['FK_GATE_ENTR'].value,
                tipoCarreta: item.NM_TIPO_CRRT ?? '---',
                quantidadeEixos: this.getQuantidadeEixos(item.QT_TOTL_EIXO),
                quantidadeCompartimentos: item.QT_CPTM,
                valorServico:
                  item.VL_SRVC.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  }) ?? '---',
                tipoCarga: item.TX_CRGA ?? '---',
                operador: item.NM_OPER ?? '---',
                inicioServico: formatarData(item.DT_SRVC_ENTR),
                gateEntrada: formatarData(item.DT_GATE_ENTR)
              };
            }
          );
        },
        error: () => {
          this.exibirMensagem('Erro ao carregar os dados', 'error');
        }
      });
  }

  getServicoById(codigoGateEntrada: number) {
    this.servicoEntradaService.GetServicoById(codigoGateEntrada).subscribe({
      next: (response: IGetServicoEntradaByIdResponse) => {
        this.form.controls['FK_SRVC'].setValue(response.FK_SRVC);
        this.form.controls['FK_TIPO_CRRT'].setValue(response.FK_TIPO_CRRT);
        this.form.controls['FK_TIPO_CRRT'].setValue(response.FK_TIPO_CRRT);
        this.form.controls['QT_TOTL_EIXO'].setValue(response.QT_TOTL_EIXO);
        this.form.controls['QT_CPTM'].setValue(response.QT_CPTM ?? 0);
        this.form.controls['FK_CRGA'].setValue(response.FK_CRGA);
        this.form.controls['DT_GATE_ENTR'].setValue(
          formatarData(response.DT_GATE_ENTR ?? new Date())
        );
        this.form.controls['DT_FILA'].setValue(
          formatarData(response.DT_SRVC_ENTR ?? new Date())
        );
        this.form.controls['PK_SRVC_ENTR'].setValue(response.PK_SRVC_ENTR ?? null);
      },
      error: () => {
        this.exibirMensagem('Erro ao carregar os dados', 'error');
      }
    });
  }

  getSelects() {
    this.getServico();
    this.getTipoCarreta();
    this.getTipoCarga();
    this.getPrecos();
  }

  getServico() {
    this.isLoading = true;
    return this.servicoService.GetServico().pipe(
      tap(response => {
        this.isLoading = false;
        this.servicosRaw = response;
        this.servicoOptions = response.map((x: IGetServico) => {
          return {
            name: x.TX_TIPO_SRVC,
            value: x.PK_SRVC
          };
        });
      })
    );
  }

  getTipoCarreta() {
    this.isLoading = true;
    return this.tipoCarretaService.GetTipoCarreta().pipe(
      tap(response => {
        this.isLoading = false;
        this.tipoCarretaOptions = response.map((x: IGetTipoCarreta) => {
          return {
            name: `${x.NM_TIPO_CRRT}`,
            value: x.PK_TIPO_CRRT
          };
        });
      })
    );
  }

  getTipoCarga() {
    this.isLoading = true;
    return this.tipoCargaService.GetCarga().pipe(
      tap(response => {
        this.isLoading = false;
        this.tipoCargaOptions = response.map((x: IGetCarga) => {
          return {
            name: `${x.TX_CRGA}`,
            value: x.PK_CRGA
          };
        });

        if (!this.isEditing && !this.isViewing && !this.form.controls['FK_CRGA'].value) {
          const fertilizante = response.find((x: IGetCarga) => x.TX_CRGA.toLowerCase().includes('fertilizante'));
          if (fertilizante) {
            this.form.controls['FK_CRGA'].setValue(fertilizante.PK_CRGA);
          }
        }
      })
    );
  }

  atualizarCampo(campo: string, valor: any): void {
    if (this.form.controls[campo].value !== valor) {
      this.form.controls[campo].setValue(valor);
    }
  }

  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find(opcao => opcao?.value === Number(value));

    this.atualizarCampo(campo, selecionado?.value);
  }

  escolherServico(value: any): void {
    this.form.controls['FK_SRVC'].setValue(value);
    this.atualizarPreco();
  }

  escolherTipoCarreta(value: any): void {
    this.form.controls['FK_TIPO_CRRT'].setValue(value);
    this.atualizarPreco();
  }

  escolherQuantidadeEixo(value: any): void {
    this.form.controls['QT_TOTL_EIXO'].setValue(value);
    this.atualizarPreco();
  }

  escolherCompartimento(value: any): void {
    this.form.controls['QT_CPTM'].setValue(value);
    this.atualizarPreco();
  }

  escolherCarga(value: any): void {
    this.form.controls['FK_CRGA'].setValue(value);
    this.atualizarPreco();
  }

  exibirMensagem(mensagem: string, type: 'success' | 'error') {
    const config: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: type === 'success' ? ['snackbar-success'] : ['snackbar-error']
    };

    this.snackBar.open(mensagem, 'Fechar', config);
  }

  goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  setDataFila() {
    if (this.isEditing) {
      return;
    }
    this.form.controls['DT_FILA'].setValue(formatarData(new Date()));
  }

  activateRoute() {
    this.subscription$.add(
      forkJoin([
        this.getServico(),
        this.getTipoCarreta(),
        this.getTipoCarga(),
        this.getPrecos()
      ]).subscribe(() => {
        this.form.controls['DT_FILA'].setValue(formatarData(new Date()));

        this.route.queryParams.subscribe(params => {
          if (
            (params['isEditing'] === 'true' ||
              params['isViewing'] === 'true') &&
            params['codigoGateEntrada']
          ) {
            this.title =
              params['isEditing'] === 'true'
                ? 'Editar Entrada de Serviço'
                : 'Visualização Entrada de Serviço';
            this.isEditing = params['isEditing'] === 'true';
            this.isViewing = params['isViewing'] === 'true';
            this.isViewing ? this.form.disable() : this.form.enable();

            this.form.controls['FK_GATE_ENTR'].setValue(
              +params['codigoGateEntrada']
            );
            this.form.controls['TX_PLCA_CAVA'].setValue(
              removeHyphen(params['placaCavalo'])
            );

            this.getServicoById(+params['codigoServico']);
            this.getEntrada();
            this.getTabela();
            return;
          }
        });
      })
    );
  }

  clearForms(): void {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;

    if (!placaCavalo) {
      this.form.controls['PK_AGND'].reset();
      this.form.reset();
    }
  }

  getQuantidadeEixos(value: number): string {
    switch (value) {
      case 3:
        return '3 Eixos';
      case 4:
        return '4 Eixos';
      case 7:
        return '7 Eixos';
      case 9:
        return '9 Eixos';
      default:
        return '---';
    }
  }

  getPrecos() {
    this.isLoading = true;
    return this.precoService.GetPreco({ status: 1, pageSize: 9999 }).pipe(
      tap(response => {
        this.isLoading = false;
        this.precosRaw = response.ITEMS;
        this.precosOptions = this.precosRaw.map((x: IGetPreco) => ({
          name: `${x.NM_PRCO}`,
          value: x.PK_PRCO
        }));
      })
    );
  }

  onPrecoSelecionado(precoId: number): void {
    if (this.isPatching || !precoId) return;

    const preco = this.precosRaw.find(p => p.PK_PRCO == precoId);
    if (!preco) return;

    this.isPatching = true;
    this.form.patchValue({
      FK_SRVC: preco.FK_SRVC ?? null,
      FK_TIPO_CRRT: preco.FK_TIPO_CRRT ?? null,
      FK_CRGA: preco.FK_CRGA ?? null,
      QT_TOTL_EIXO: preco.QT_TOTL_EIXO ?? null,
      QT_CPTM: preco.QT_CPTM ?? null
    }, { emitEvent: false });
    this.isPatching = false;
    this.cd.detectChanges();
  }

  private atualizarPreco(): void {
    if (this.isPatching || this.isViewing) return;

    if (this.timeoutPreco) clearTimeout(this.timeoutPreco);

    this.timeoutPreco = setTimeout(() => {
      this.executarAtualizarPreco();
    }, 150);
  }

  private executarAtualizarPreco(): void {
    const { FK_SRVC, FK_TIPO_CRRT, QT_TOTL_EIXO, QT_CPTM, FK_CRGA } = this.form.getRawValue();

    const srvc = FK_SRVC === '' ? null : FK_SRVC;
    const crrt = FK_TIPO_CRRT === '' ? null : FK_TIPO_CRRT;
    const eixo = QT_TOTL_EIXO === '' ? null : QT_TOTL_EIXO;
    const cptm = QT_CPTM === '' ? null : QT_CPTM;
    const crga = FK_CRGA === '' ? null : FK_CRGA;

    const matchedPrecos = this.precosRaw.filter(p =>
      (p.FK_SRVC == srvc || p.FK_SRVC == null) &&
      (p.FK_TIPO_CRRT == crrt || p.FK_TIPO_CRRT == null) &&
      (p.QT_TOTL_EIXO == eixo || p.QT_TOTL_EIXO == null || (eixo == 0 && p.QT_TOTL_EIXO == null)) &&
      (p.QT_CPTM == cptm || p.QT_CPTM == null || (cptm == 0 && p.QT_CPTM == null)) &&
      (p.FK_CRGA == crga || p.FK_CRGA == null || (crga == 0 && p.FK_CRGA == null))
    );

    const preco = matchedPrecos.sort((a, b) => {
      const aNulls = [a.FK_SRVC, a.FK_TIPO_CRRT, a.QT_TOTL_EIXO, a.QT_CPTM, a.FK_CRGA].filter(v => v == null).length;
      const bNulls = [b.FK_SRVC, b.FK_TIPO_CRRT, b.QT_TOTL_EIXO, b.QT_CPTM, b.FK_CRGA].filter(v => v == null).length;
      return aNulls - bNulls;
    })[0];

    if (preco && this.form.controls['PK_PRCO'].value !== preco.PK_PRCO) {
      this.form.controls['PK_PRCO'].setValue(preco.PK_PRCO, { emitEvent: false });
    } else if (!preco) {
      this.form.controls['PK_PRCO'].setValue(null, { emitEvent: false });
    }
    this.cd.detectChanges();
  }

  getCaixaAtual() {
    this.caixaService.GetCaixaAtual().subscribe({
      next: res => {
        this.NU_TIPO_CAIX = res?.NU_TIPO_CAIX ?? null;

        if (this.NU_TIPO_CAIX === 1) {
          const hasActions = this.tableColumns.some(c => c.key === 'actions');
          if (!hasActions) {
            this.tableColumns.push({
              header: 'Ações',
              key: 'actions',
              type: 'buttons',
              buttons: [
                {
                  label: 'Baixar Ticket',
                  img: 'assets/icon-download.svg',
                  action: (item: any) => this.downloadTicket(item.idGateEntrada)
                },
                {
                  label: 'Impressão Ticket',
                  img: 'assets/icon-print.svg',
                  action: (item: any) => this.imprimirTicket(item.idGateEntrada)
                }
              ]
            });
          }
        }
      }
    });
  }

  downloadTicket(id: number) {
    if (!id) return;
    this.isLoading = true;
    this.entradaGateService.GetReceiptGateEntradaById(id, 0).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  imprimirTicket(id: number) {
    if (!id) return;
    this.isLoading = true;
    this.entradaGateService.GetReceiptGateEntradaById(id, 1).subscribe({
      next: (response: IGetReportBase64) => {
        this.isLoading = false;
        this.impressoraService.impressoraTicket(
          response.ReportBase64,
          'text/plain'
        );
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
}
